import * as React from 'react';
import { useSelector } from 'react-redux';
import { theme as grooveTheme } from '@groove-labs/groove-ui';
import { withStyles, createStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';

import {
  makeGetReportIsValid,
  makeGetReportMessage,
} from 'Modules/PeopleImportDialog/submodules/reports/selectors/validateReport';

const classes = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: 350,
  },
  warningIcon: {
    color: theme.palette.error.main,
    paddingRight: grooveTheme.spacing.unit,
  },
  successIcon: {
    color: theme.palette.success.main,
    paddingRight: grooveTheme.spacing.unit,
  },
});
const styles = createStyles(classes);

const VALID_REPORT_TEXT = 'Report Verified';
const FAILED_REPORT_TEXT =
  'We have detected that this report may not contain valid records to import. Please make sure your report has Salesforce Contacts, Leads, or Campaign Members.';
const NO_CONTACT_LEAD_ERROR_MESSAGE = 'No contact or lead column found';

type ValidationResultPropTypes = {
  classes: {
    root: string;
    warningIcon: string;
    successIcon: string;
  };
  reportSfdcId: string;
};

const ValidationResult: React.FC<ValidationResultPropTypes> = ({
  classes,
  reportSfdcId,
}) => {
  const reportIsValid = useSelector(makeGetReportIsValid(reportSfdcId));
  const reportMessage = useSelector(makeGetReportMessage(reportSfdcId));

  return reportIsValid ? (
    <div className={classes.root}>
      <CheckCircleIcon classes={{ root: classes.successIcon }} />
      <Typography variant="caption">{VALID_REPORT_TEXT}</Typography>
    </div>
  ) : (
    <div className={classes.root}>
      <CancelIcon classes={{ root: classes.warningIcon }} />
      <Typography variant="caption">
        {NO_CONTACT_LEAD_ERROR_MESSAGE === reportMessage
          ? FAILED_REPORT_TEXT
          : reportMessage}
      </Typography>
    </div>
  );
};

ValidationResult.displayName = 'ValidationResult';

export default withStyles(styles)(ValidationResult);
